<template>
  <div>
    <v-row v-if="name" :class="expanded ? 'bpcreator-expanded-item' : ''">
      <!-- OBJECT PROP NAME -->
      <v-col cols="2" class="d-flex">
        <StringInput
          :readonly="name_readonly || readonly_status"
          :value="name || ''"
          @update="update_name"
        />
      </v-col>

      <!-- OBJECT ACTIONS -->
      <v-col
        v-if="typeof(value) == 'object'"
        cols="9"
        class="d-flex bpcreator-object-expland" 
        @click.stop="expand(name)"
      >
        <slot name="extra_actions">

        </slot>
        <DeleteButton
          v-if="!readonly"
          :text="name"
          class="bpcreator-object-expland-button"
          @submit="delete_value(name)"
        />
        <v-icon medium> {{expanded ? 'mdi-chevron-down' : 'mdi-chevron-right'}}</v-icon>
      </v-col>
      <!-- NO OBJECT, SHOW VALUE -->
      <v-col v-else cols="2">
        <component
          v-if="input_type"
          :is="input_type"
          :readonly="readonly_status"
          :value="value"
          :roles="roles"
          @update="update"
          @delete="delete_value"
        />
      </v-col>
      <!-- DELETE BUTTON IF IS OBJECT???? -->
      <v-col v-if="!(typeof(value) == 'object')">
        <DeleteButton
          v-if="!readonly && roles['isAdmin']"
          :text="name"
          @submit="delete_value(name)"
        />
      </v-col>
    </v-row>

    <!-- VALUE IF OBJECT -->
    <v-row v-if="input_type && (!name || expanded)">
      <v-col>
        <component
          v-if="input_type && (!name || expanded)"
          :is="input_type"
          :readonly="readonly_status"
          :value="JSON.parse(JSON.stringify(value))"
          :roles="roles"
          @click.stop
          @update="update"
          @delete="delete_value"
        />
      </v-col>
    </v-row>
  </div>
</template>

<style lang="css">
  .bpcreator-expanded-item {
    background-color: #d3d3d3;
  }
  .bpcreator-object-expand {
    cursor: pointer;
  }
  .bpcreator-object-expand-button {
    margin-left: 100%;
    margin-right: 0px;
  }
</style>
  
<script>
  import StringInput from '@/components/bpcreator/inputs/StringInput';
  import ArrayInput from '@/components/bpcreator/inputs/ArrayInput';
  import DictInput from '@/components/bpcreator/inputs/DictInput';
  import BooleanInput from '@/components/bpcreator/inputs/BooleanInput';
  import NumericInput from '@/components/bpcreator/inputs/NumericInput';

  import DeleteButton from '@/components/DeleteButton';

  export default {
    components: {
      StringInput,
      ArrayInput,
      DictInput,
      BooleanInput,
      NumericInput,
      DeleteButton,
    },
      
    name: 'Input',
      
    props: {
      name: String,
      value: {},
      readonly: Boolean,
      name_readonly:  Boolean,
      hidde_name: Boolean,
      roles: {default: ()=>({})},
    },
      
    data: () => ({
      deafult_input: {
        id: '',
        label: '',
        required: false,
        value: '',
        readonly: false,
        cols: 4,
        class: null,
        component: 'TextInput',
        placeholder: "",
      },
      expanded: false,
    }),
      
    computed: {
      aaa() {
        return typeof(this.value)
      },
      readonly_status() {
        return this.readonly || !this.roles['isAdmin'];
      },

      input_type() {
        const type = typeof(this.value);
        if (Array.isArray(this.value)) {
          return 'ArrayInput'
        } else if (type == 'object') {
          return 'DictInput'
        } else if (type == 'boolean'){
          return "BooleanInput"
        } else if (type == 'number'){
          return "NumericInput"
        } else {
          return "StringInput"
        }
      },
    },
      
    mounted() {
    },
      
    methods: {
      update(value) {
          this.$emit('update',value);
      },

      update_name(value) {
        if (value) {
          this.$emit('update',{[value]: this.value}, value);
        }
      },

      delete_value(name) {
        this.$emit('delete',name);
      },

      expand(id) {
        /*this.expanded[id] = !this.expanded[id];
        this.expanded = {...this.expanded};*/
        this.expanded = !this.expanded;
      }
    },
  
    watch: {
    },
  }
</script>